import store from '../store'

export default function authHeader () {
  if (store.getters.isLogged) {
    return { 'x-auth-token': localStorage.token }
  }

  if (!store.getters.isLogged) {
    return {}
  }
}
